export default __webpack_public_path__ + "static/media/Randomizer.7ce87064.JPG";